import { useContext } from 'react';
import WidgetContext from './WidgetContext';
import { useState } from 'react';
import { STEPS } from './steps';
import PaymentMethod from './PaymentMethod';
import Spinner from './Spinner';
import { assign, includes, filter, some } from 'lodash';
import DiscountCodes from './DiscountCodes';
import CustomField from './CustomField';
import { calculateCustomFieldsPerPurchase, calculateApplicableDiscountCodes } from './utils';


export default function Checkout() {
    const { ticketing, contingents, setStep, answers, setAnswers, defaultCustomFieldsPerPurchase, gotoPaymentProvider, discountCodes, setDiscountCodes, automaticDiscountCodes, TICKETING_BASE_URL } = useContext(WidgetContext);
    const [paymentMethod, setPaymentMethod] = useState('paypal');
    const [paymentStarted, setPaymentStarted] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    const customFieldsPerPurchase = calculateCustomFieldsPerPurchase(contingents, defaultCustomFieldsPerPurchase);

    function checkRequiredFields() {
				// Checks all custom fields and sends alerts and puts them into a new answer object
				var answer = {};
        for (let field of customFieldsPerPurchase) {
            if (field.is_required) {
							  if (includes(['text', 'text_area', 'email'], field.type)) {
                    let answer = answers[field.id];
								    if ((answer || '').trim() === '') {
									      return 'Bitte folgendes Feld ausfüllen:\n' + field.question;
								    }
							  } else if (field.type === 'select') {
                    let answer = answers[field.id];
								    if (!answer || answer === '__default') {
                        return 'Bitte folgendes Feld ausfüllen:\n' + field.question;
								    }
							  } else if (field.type === 'checkbox') {
                    let answer = answers[field.id];
                    if (!answer) {
                        return 'Bitte folgendes Feld ausfüllen:\n' + field.question;
                    }
							  }
            }
				}
    }

    function validateFields() {
        // Check email addresses.
				if (answers['email'].trim() !== answers['emailConfirmation'].trim()) {
						return 'Die beiden Email Adressen stimmen nicht überein';
				}
        
        return null;
		}


    function validateInviteOnlyContingents() {
        const applicableDiscountCodes = calculateApplicableDiscountCodes(contingents, automaticDiscountCodes, discountCodes);
				for (let c of filter(contingents, 'count')) {
					  // If it is not invite only, we're good to go
					  if (!c.is_invite_only) {
						    continue;
					  }

					  // If no matching discount code is found, we return false.
						if (!some(applicableDiscountCodes, d => d.contingent_id == c.id || (d.contingent_id === null && d.event_id === c.event_id))) {
							  return 'Einige Produkte benötigen einen Code';
						}
				}
				return null;
		}

    function startPayment() {
        let errorMsg = checkRequiredFields();
        if (errorMsg) {
            setErrorMsg(errorMsg);
            return;
        }

        errorMsg = validateFields();
        if (errorMsg) {
            setErrorMsg(errorMsg);
            return;
        }

        errorMsg = validateInviteOnlyContingents();
        if (errorMsg) {
            setErrorMsg(errorMsg);
            return;
        }
        
        setPaymentStarted(true);
        gotoPaymentProvider(paymentMethod);
    }

    let buttonState = {
        label: 'Jetzt kostenpflichtig kaufen',
        disabled: false,
        loader: false
    };

    if (!!checkRequiredFields()) {
        buttonState = {
            label: 'Jetzt kostenpflichtig kaufen',
            disabled: true,
            loader: false
        };
    } else if (paymentStarted) {
        buttonState = {
            label: 'Sie werden weitergeleitet...',
            disabled: true,
            loader: true
        };
    }

    return (
        <div className="p-3 lg:w-2/3 bg-light_brown rounded flex flex-col px-4 lg:px-16 items-start lg:overflow-y-auto">
          <h2 className="text-lg font-bold mt-6 mb-4">Ihre Details</h2>
          <div className="flex flex-row flex-wrap w-full">
            {
                customFieldsPerPurchase.map(field => (
                    <CustomField
                      key={field.id}
                      field={field}
                      answer={answers[field.id]}
                      setAnswer={answer => setAnswers(assign({...answers}, {[field.id]: answer}))}/>
                ))
            }
          </div>
          <h2 className="text-lg font-bold mt-8 mb-6">Zahlungsmethode wählen</h2>
          <div className="flex flex-row mb-4 flex-wrap justify-center lg:justify-start">
            {ticketing.enabled_payment_methods.map(method => (
                <PaymentMethod key={method} method={method} selected={paymentMethod === method} onSelect={() => setPaymentMethod(method)}></PaymentMethod>
            ))
            }
          </div>
          <p className="text-sm">Sie werden im nächsten Schritt zum Bezahldienstleiter weitergeleitet um die Bestellung abzuschlie&szlig;en</p>
          <h2 className="text-lg font-bold mt-8 mb-6">Rabatt- und Gutscheincodes</h2>          
          <DiscountCodes TICKETING_BASE_URL={TICKETING_BASE_URL} contingents={contingents} discountCodes={discountCodes} setDiscountCodes={setDiscountCodes}/>
          <div className="mt-8 flex flex-col w-full justify-center lg:justify-start">
            {errorMsg && <div className="text-red-500">{errorMsg}</div>}
            <button
              className={`mt-2 px-6 py-2 flex flex-row items-center w-full justify-center lg:w-auto mb-4 lg:mb-0 rounded-full uppercase text-white font-bold ${buttonState.disabled ? 'bg-black opacity-50 cursor-wait' : 'bg-gold'}`}
              onClick={startPayment}
            >
              {buttonState.loader && <div className="mr-1"><Spinner /></div>}
              {buttonState.label}
            </button>
            <div className="mt-1 opacity-60 text-sm">* Pflichtfelder</div>
          </div>
        </div>
    );
}
